<app-general-modal-layout>
  <h1 class="text-3xl font-bold text-neutral-950 text-center mb-5">
    Begin New Application
  </h1>
  <form [formGroup]="applicationTypeForm">
    <app-ccs-select
      displayKey="label"
      valueKey="value"
      [options]="applicationTypes"
      [label]="'Application Type'"
      [placeholder]="'Select Application Type'"
      formControlName="applicationType" />
    <div class="flex gap-6 mt-20 justify-between">
      <ui-button
        variant="secondary"
        [outline]="true"
        appCloseModal
        class="w-full"
        >Cancel</ui-button
      >
      <ui-button
        [portalSource]="portalSource"
        variant="primary"
        appApplicationTypeSubmit
        [form]="applicationTypeForm"
        [dialogRef]="dialogRef"
        class="w-full"
        >Create</ui-button
      >
    </div>
  </form>
</app-general-modal-layout>
